import React, { useEffect, useState, useRef } from 'react';
import api from '../services/api';
import '../css/requisition-app-styles.css';
import { Link } from 'react-router-dom';
import TopBarIcons from './TopBarIcons';
import axios from 'axios';
import Select from "react-select";
import { useNavigate } from "react-router-dom";
import Sidebar from './Sidebar';
import styled from "styled-components";

import PrintButton from './PrintButton';
import ExportPDFButton from './ExportPDFButton';
import ExportExcelButton from './ExportExcelButton';

import { useReactToPrint } from 'react-to-print';
import { DateTime } from "luxon";
import PopupModal from "./PopupModal";
import { faCheckCircle, faTimesCircle } from '@fortawesome/free-solid-svg-icons';
import LoadingOverlay from "./LoadingOverlay";
import { faWifi } from '@fortawesome/free-solid-svg-icons';
import '../css/RequisitionForm.css';

// ===== ERROR GROUPING FUNCTIONS (MUST BE DEFINED BEFORE ValidationErrorList) =====
const groupValidationErrors = (errors) => {
  const grouped = {
    requiredFields: [],
    activityErrors: [],
    projectDetails: [],
    paymentErrors: [],
    dateErrors: [],
    costDriverErrors: [],
    districtErrors: [],
    tableWarnings: [],
    budgetErrors: []
  };

  errors.forEach(error => {
    // More specific rules first
    if (error.includes('Budget') || error.includes('budget')) {
      grouped.budgetErrors.push(error);
    } else if (error.includes('Pay Mode') || error.includes('Bank') || error.includes('Account') || error.includes('Phone Number')) {
      grouped.paymentErrors.push(error);
    } else if (error.includes('Date') || error.includes('from') || error.includes('to') || error.includes('duration')) {
      grouped.dateErrors.push(error);
    } else if (error.includes('Cost Driver')) {
      grouped.costDriverErrors.push(error);
    } else if (error.includes('District') || error.includes('Area Program')) {
      grouped.districtErrors.push(error);
    } else if (error.includes('table') || error.includes('empty') || error.includes('Warning')) {
      grouped.tableWarnings.push(error);
    } else if (error.includes('Project') || error.includes('Budget Line')) {
      grouped.projectDetails.push(error);
    } else if (error.includes('Activity') || error.includes('Target') || error.includes('Impact') || error.includes('Purpose')) {
      grouped.activityErrors.push(error);
    } else {
      grouped.requiredFields.push(error);
    }
  });

  return grouped;
};

const formatGroupedErrors = (groupedErrors) => {
  const formattedMessages = [];
  
  // Only add sections that have errors (no emojis)
  const errorGroups = [
    { key: 'activityErrors', label: 'Activity Details' },
    { key: 'projectDetails', label: 'Project & Advance Details' },
    { key: 'paymentErrors', label: 'Payment Information' },
    { key: 'districtErrors', label: 'Location Details' },
    { key: 'dateErrors', label: 'Date Validation' },
    { key: 'costDriverErrors', label: 'Cost Drivers' },
    { key: 'tableWarnings', label: 'Table Warnings' },
    { key: 'budgetErrors', label: 'Budget Line' },
    { key: 'requiredFields', label: 'Other Required Fields' }
  ];

  errorGroups.forEach(({ key, label }) => {
    if (groupedErrors[key] && groupedErrors[key].length > 0) {
      formattedMessages.push(`[${label}]`);
      formattedMessages.push(...groupedErrors[key]);
    }
  });

  return formattedMessages;
};

const getErrorSummary = (groupedErrors) => {
  const totalErrors = Object.values(groupedErrors).reduce(
    (sum, errors) => sum + errors.length, 0
  );
  
  if (totalErrors === 0) return null;
  
  const criticalErrors = [
    ...groupedErrors.requiredFields,
    ...groupedErrors.activityErrors,
    ...groupedErrors.projectDetails,
    ...groupedErrors.districtErrors,
    ...groupedErrors.paymentErrors,
    ...groupedErrors.budgetErrors,
    ...groupedErrors.dateErrors
  ].length;
  
  const warnings = groupedErrors.tableWarnings.length;
  
  return {
    total: totalErrors,
    critical: criticalErrors,
    warnings: warnings
  };
};

// ===== VALIDATION ERROR LIST COMPONENT =====
const ValidationErrorList = ({ errors }) => {
  if (!errors || errors.length === 0) return null;
  
  const groupedErrors = groupValidationErrors(errors);
  const formattedErrors = formatGroupedErrors(groupedErrors);
  const summary = getErrorSummary(groupedErrors);
  
  return (
    <div>
        {/* Error Summary  */}
        {summary && (
          <div className="error-summary">
            <span className="error-count-badge">
              {summary.total} {summary.total === 1 ? 'issue' : 'issues'} found
            </span>
            {/*
              {summary.critical > 0 && (
                <span className="critical-count">{summary.critical} critical</span>
              )}
                */
            }
            {summary.warnings > 0 && (
              <span className="warning-count">{summary.warnings} warnings</span>
            )}
          </div>
        )}
        
        {/* Error List*/}
        <ul className="validation-error-list">
          {formattedErrors.map((error, index) => {
            // Check if this is a section header
            if (error.startsWith('[') && error.endsWith(']')) {
              const sectionName = error.slice(1, -1);
              return (
                <li key={index} className="group-header">
                  {sectionName}
                </li>
              );
            }
            
            // Determine error type for styling
            let className = '';
            if (error.includes('Warning') || error.includes('table') || error.includes('empty')) {
              className = 'warning-item';
            } else if (error.includes('Budget') || error.includes('Payment') || error.includes('Bank')) {
              className = 'info-item';
            }
            
            return (
              <li key={index} className={className}>
                {error}
              </li>
            );
          })}
        </ul>
      </div>
    );
  };

    const districts = [
      "Balaka", "Blantyre", "Chikwawa", "Chiradzulu", "Chitipa", "Dedza", "Dowa", "Karonga", "Kasungu",
      "Likoma", "Lilongwe", "Machinga", "Mangochi", "Mchinji", "Mulanje", "Mwanza", "Mzimba", "Neno",
      "Nkhata Bay", "Nkhotakota", "Nsanje", "Ntcheu", "Ntchisi", "Phalombe", "Rumphi", "Salima", "Thyolo", "Zomba"
    ];

   

    const StyledInput = styled.input`
  /* Styles for the input */
  border: 1px solid #ccc;
  padding: 8px;
  font-size: 16px;
  width: 100%;

  /* Placeholder-specific styles */
  &::placeholder {
    font-size: 12px; 
    color: grey;  
  }
`;


    
    const getFixedTodayDate = () => {
      return DateTime.now().setZone("Africa/Harare").toISODate(); 
    };

  
  
/*
    const generateRequisitionID = (fullName, phoneNumber, currentRequisitionsOnDate) => {
      const now = DateTime.now().setZone("Africa/Harare"); 
      
      const year = now.year.toString().slice(-2);
      const month = now.month.toString().padStart(2, '0');
      const day = now.day.toString().padStart(2, '0');

      const nameParts = fullName.trim().split(' ');
      const firstInitial = nameParts[0]?.charAt(0).toUpperCase() || '';
      const lastInitial = nameParts[1]?.charAt(0).toUpperCase() || '';
      const initials = `${firstInitial}${lastInitial}`;

      const requisitionNumber = (currentRequisitionsOnDate + 1).toString().padStart(2, '0');

      return `${initials}${year}${month}${day}${phoneNumber}${requisitionNumber}`;
    };

*/
    
    const RequisitionForm = () => {
      const navigate = useNavigate();

      const [showValidationErrorModal, setShowValidationErrorModal] = useState(false);
      const [validationErrorMessages, setValidationErrorMessages] = useState([]);

      const [showEmptyTableWarning, setShowEmptyTableWarning] = useState(false);
      const [showCostDriverWarning, setShowCostDriverWarning] = useState(false);
      

      const [isBlastingRowAdded, setIsBlastingRowAdded] = useState(false);
    const [blastingCostItems, setBlastingCostItems] = useState([
    { costDriver: '', isCustom: false, customCostDriver: '', justification: '', quantity: '', unitPrice: '', total: '', supportDocuments: '' }
]);
      const [blastingTotalTotal, setBlastingTotalTotal] = useState(0);
      
      const [isSubmitting, setIsSubmitting] = useState(false);
      const [submitAttempted, setSubmitAttempted] = useState(false);
      
      const [showModal, setShowModal] = useState(false);

      const [showErrorModal, setShowErrorModal] = useState(false);
      const [showNoInternetModal, setShowNoInternetModal] = useState(false);

      const [costDriverOptions, setCostDriverOptions] = useState([]); 

      const handleModalClose = () => {
        
        navigate('/requisitions');
      };
      const handleErrorModalClose = () => {
        setShowErrorModal(false);
      };
      
      const handleNoInternetModalClose = () => {
        console.log("Closed No Internet modal");
        setShowNoInternetModal(false);
      };

      const getDefaultUnitPrice = (driverName) => {
        const match = costDriverOptions.find(opt => opt.costDriver === driverName);
        const price = match?.defaultUnitPrice;
        return price > 0 ? price.toString() : "";
      };
      


      const getSupportDocuments = (driverName) => {
        const match = costDriverOptions.find(opt => opt.costDriver === driverName);
        return match?.supportDocuments || "Receipt(s)";
      };
      

      const contentRef = useRef();

      const handlePrint = () => {
        const content = document.getElementById('printable-area').innerHTML;
        const printWindow = window.open('', '_blank', 'width=800,height=600');
        printWindow.document.open();
        printWindow.document.write(`
            <html>
            <head>
                <title>Print</title>
                <style>
                    body { font-family: Arial, sans-serif; padding: 20px; }
                </style>
            </head>
            <body>
                ${content}
            </body>
            </html>
        `);
        printWindow.document.close();
        printWindow.focus();
        printWindow.print();
        printWindow.close();
    };


    const fullName = localStorage.getItem('fullName') || "Name";

        const theUserType = localStorage.getItem('userType');
        const theUserId = localStorage.getItem('userId');  
        const theSupervisorName = localStorage.getItem('supervisorName');  
        const theStaffLevel = localStorage.getItem('staffLevel');    
        const thePhoneNumber = localStorage.getItem('phoneNumber');   

        const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
        const staticBaseUrl = process.env.REACT_APP_STATIC_BASE_URL;

        const signatureFilePath = localStorage.getItem("signatureFilePath");

        const signatureUrl = signatureFilePath
          ? `${staticBaseUrl}/${signatureFilePath}`
          : `${staticBaseUrl}/signatures/default-signature.jpg`;
 
        

        //const [currentRequisitionsOnDate, setCurrentRequisitionsOnDate] = useState(0);

        const [costDriversData, setCostDriversData] = useState([]);
        const [isRowAdded, setIsRowAdded] = useState(false); 


        const [isConfirmed, setisConfirmed] = useState(false);

        const [formArray, setFormArray] = useState([]);
        const handleAddToExport = () => {
          setFormArray((prev) => [...prev, { ...formData }]);
        };
      
      
        const handleCheckboxChange = () => {
          setisConfirmed((prev) => !prev);
        };
        
      const handleBlastingInputChange = (index, field, value) => {
        const newItems = [...blastingCostItems];
        
        if (field === 'costDriver') {
          // Handle cost driver selection
          newItems[index].costDriver = value;
          // If "Other" is selected, set isCustom to true
          if (value === 'Other') {
            newItems[index].isCustom = true;
            newItems[index].customCostDriver = '';
          } else {
            newItems[index].isCustom = false;
            newItems[index].customCostDriver = '';
            // Set default support documents and unit price if available
            const supportDoc = getSupportDocuments(value);
            if (supportDoc) newItems[index].supportDocuments = supportDoc;
            const defaultPrice = getDefaultUnitPrice(value);
            if (defaultPrice) newItems[index].unitPrice = defaultPrice;
          }
        } else if (field === 'unitPrice') {
          // Remove any non-numeric characters except decimal point
          const cleanValue = value.replace(/[^0-9.]/g, '');
          newItems[index][field] = cleanValue;
          
          // Recalculate total if quantity exists
          if (newItems[index].quantity) {
            const quantity = Number(newItems[index].quantity || 0);
            const unitPrice = Number(cleanValue || 0);
            const total = quantity * unitPrice;
            newItems[index].total = total;
          }
        } else if (field === 'quantity') {
          // Remove commas and non-numeric characters for quantity
          const cleanValue = value.replace(/,/g, '');
          newItems[index][field] = cleanValue;
          
          // Recalculate total if unitPrice exists
          if (newItems[index].unitPrice) {
            const quantity = Number(cleanValue || 0);
            const unitPrice = Number(newItems[index].unitPrice || 0);
            const total = quantity * unitPrice;
            newItems[index].total = total;
          }
        } else {
          newItems[index][field] = value;
        }

        setBlastingCostItems(newItems);
      };


  const [fields, setFields] = useState([
    { district: "", areaProgram: "" }
  ]);

  
    
        const addRow = () => {
          setCostItems([
            ...costItems,
            {
              costDriver: '',
              isCustom: false,
              customCostDriver: '',
              justification: '',
              quantity: '',
              unitPrice: '',
              total: '',
              supportDocuments: '',
            },
          ]);
          setIsRowAdded(true); 
        };
        
        
        const removeRow = (index) => {
          const updatedCostItems = costItems.filter((_, i) => i !== index);
          setCostItems(updatedCostItems);
          if (updatedCostItems.length === 1) {
            setIsRowAdded(false); 
          }
        };

      const addBlastingRow = () => {
          setBlastingCostItems([
            ...blastingCostItems,
            { 
              costDriver: '', 
              isCustom: false, 
              customCostDriver: '', 
              justification: '', 
              quantity: '', 
              unitPrice: '', 
              total: '', 
              supportDocuments: '' 
            }
          ]);
          setIsBlastingRowAdded(true);
        };

       const removeBlastingRow = (index) => {
            const updatedItems = blastingCostItems.filter((_, i) => i !== index);
            setBlastingCostItems(updatedItems);
            if (updatedItems.length === 1) {
                setIsBlastingRowAdded(false);
            }
        };
        const [formData, setFormData] = useState(() => {
                  
          return {
              country: '',
              staffName: fullName,
              staffLevel: theStaffLevel,
              projectCode: '',
              activityPurpose: '',
              projectName: '',
              from: '',
              to: '',
              activityName: '',
              hubOffice: '',
              supervisorName: theSupervisorName,
              budgetLineCode: '',
              targetClient: '',
              expectedImpact: '',
              userType: theUserType,
              userId: theUserId,
              payMode: '',
              bankName:'',
              branch:'',
              accountNumber: '',
              phoneNumber: '',
              requisitionDate: getFixedTodayDate(), 
              requisitionID: '',
              status: 'Draft',  
              costDrivers: [{ costDriver: '', customCostDriver: '' }], 
              districtAndAreaProgramPairs: [
                { district: "", areaProgram: "" }
              ], 
              requesterComment: '',
            };
          });

          
          useEffect(() => {
            const fetchCostDrivers = async () => {
              try {
                const { data } = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/CostDriverOptions`);
                const list = Array.isArray(data) ? data : data.$values || [];
                setCostDriverOptions(list);
              } catch (err) {
                console.error(err);
                setCostDriverOptions([]);
              }
            };
            fetchCostDrivers();
          }, []);
          
          
          
          
          useEffect(() => {
            setFormData((prev) => ({
                ...prev,
                requisitionDate: getFixedTodayDate(),
            }));
        }, []);

        /*
        useEffect(() => {
          const fetchRequisitionsCount = async () => {
            try {
              const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/requisition/count/today/${theUserId}`);
              setCurrentRequisitionsOnDate(response.data);
            } catch (error) {
              console.error('Error fetching requisitions count:', error);
              setCurrentRequisitionsOnDate(0);
            }
          };
          
          if (theUserId) {  
            fetchRequisitionsCount();
          }
        }, [theUserId]);
         */


      useEffect(() => {
        const fetchData = async () => {
          try {
            const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/ActivityProjectAdvanceDetails/${formData.userId}`);
            
            if (response.ok) {
              const details = await response.json();
              setFormData((prevState) => ({
                ...prevState,
                country: details.country || '',
                hubOffice: details.hubOffice || '',
                projectCode: details.projectCode || '',
                budgetLineCode: details.budgetLineCode || '',
                projectName: details.projectName || '',
                payMode: details.payMode || '',
                bankName: details.bankName || '',
                branch: details.branch || '',
                accountNumber: details.accountNumber || '',
                phoneNumber: details.phoneNumber || '',
              }));
            } else {
              console.error('Failed to fetch details.');
            }
          } catch (error) {
            console.error('Error fetching data:', error);
          }
        };

        if (formData.userId) {
          fetchData();
        }
      }, [formData.userId]); 

      
        

                
        const [payMode, setPayMode] = useState(''); 

        const handlePayModeChange = (e) => {
            setPayMode(e.target.value); 
        }

        
        
        const status = "Draft";
      
        const handleFieldChange = (index, field, value) => {
          const updatedFields = [...fields];
          updatedFields[index][field] = value;
          setFields(updatedFields);
        };

        
        const addFieldSet = () => {
          setFields([...fields, { district: "", areaProgram: "" }]);
        };
              
             
          const [costItems, setCostItems] = useState([
            { costDriver: '', isCustom: false, customCostDriver: '', justification: '', quantity: '', unitPrice: '', total: '', supportDocuments: '', totalTotal: '' }
          ]);

          const [totalTotal, setTotalTotal] = useState(0); 





          useEffect(() => {

            const newTotalTotal = costItems.reduce((acc, item) => acc + (Number(item.quantity || 0) * Number(item.unitPrice || 0)), 0);
          
            setTotalTotal(newTotalTotal);
          }, [costItems]); 
          
          
          const handleInputChange = (index, field, value) => {
            const newItems = [...costItems];
            newItems[index][field] = value;

            if (field === 'costDriver') {
              newItems[index].isCustom = value === 'Other';
              if (value !== 'Other') {
                newItems[index].customCostDriver = '';
              }
            }
        
            if (field === 'quantity' || field === 'unitPrice') {
                const quantity = Number(newItems[index].quantity || 0);
                const unitPrice = Number(newItems[index].unitPrice || 0);
                const total = quantity * unitPrice;
                newItems[index].total = total; 
            }
        
            setCostItems(newItems);
        
            const newTotalTotal = newItems.reduce((acc, item) => acc + (Number(item.quantity || 0) * Number(item.unitPrice || 0)), 0);
        
            setTotalTotal(newTotalTotal);
        };
        
       // Function to check if a table has any data (partial or complete)
      const hasAnyData = (items) => {
        return items.some(item => 
          item.costDriver || 
          item.justification || 
          item.quantity || 
          item.unitPrice || 
          item.supportDocuments
        );
      };                   

const validateFormBeforeSubmit = () => {
  const errors = [];

  // ===== 1. REQUIRED FIELDS VALIDATION =====
  const requiredFields = [
    { field: 'activityName', label: 'Activity Name' },
    { field: 'activityPurpose', label: 'Activity Purpose' },
    { field: 'from', label: 'From date' },
    { field: 'to', label: 'To date' },
    { field: 'targetClient', label: 'Target Client' },
    { field: 'expectedImpact', label: 'Expected Impact' },
    { field: 'country', label: 'Country' },
    { field: 'hubOffice', label: 'Hub Office' },
    { field: 'projectCode', label: 'Project Code' },
    { field: 'budgetLineCode', label: 'Budget Line Code' },
    { field: 'projectName', label: 'Project Name' },
    { field: 'payMode', label: 'Pay Mode' }
  ];

  requiredFields.forEach(({ field, label }) => {
    if (!formData[field]) {
      errors.push(`${label} is required`);
    }
  });

  // ===== 2. DATE VALIDATION =====
  if (formData.from && formData.to) {
    const fromDate = new Date(formData.from);
    const toDate = new Date(formData.to);
    
    if (fromDate > toDate) {
      errors.push('From date cannot be later than To date');
    }
    
    const diffDays = Math.ceil((toDate - fromDate) / (1000 * 60 * 60 * 24));
    if (diffDays > 30) {
      errors.push('Activity duration cannot exceed 30 days');
    }
  }

  // ===== 3. PAYMENT VALIDATION =====
  if (formData.payMode === 'Bank') {
    if (!formData.bankName) errors.push('Bank Name is required for Bank payment');
    if (!formData.branch) errors.push('Branch is required for Bank payment');
    if (!formData.accountNumber) errors.push('Account Number is required for Bank payment');
    
    if (formData.accountNumber && !/^\d{10,}$/.test(formData.accountNumber)) {
      errors.push('Account Number should be at least 10 digits');
    }
  }

  if (['Airtel Money', 'TNM Mpamba'].includes(formData.payMode)) {
    if (!formData.phoneNumber) errors.push(`Phone Number is required for ${formData.payMode}`);
    
    if (formData.phoneNumber && !/^(0\d{9})$/.test(formData.phoneNumber)) {
      errors.push('Phone Number should be 10 digits starting with 0');
    }
  }

  // ===== 4. COST DRIVER VALIDATION =====
  const isRowFilled = (item) => {
    return item.costDriver && 
          item.costDriver.trim() !== '' && 
          item.justification && 
          item.justification.trim() !== '' && 
          item.quantity && 
          Number(item.quantity) > 0 && 
          item.unitPrice && 
          Number(item.unitPrice) > 0 && 
          item.supportDocuments && 
          item.supportDocuments.trim() !== '';
  };

  const hasFilledOtherCostDriver = costItems.some(item => isRowFilled(item));
  const hasFilledBlastingCostDriver = blastingCostItems.some(item => isRowFilled(item));

  const isOtherTableEmpty = costItems.every(item => 
    !item.costDriver && 
    !item.justification && 
    !item.quantity && 
    !item.unitPrice && 
    !item.supportDocuments
  );

  const isBlastingTableEmpty = blastingCostItems.every(item => 
    !item.costDriver && 
    !item.justification && 
    !item.quantity && 
    !item.unitPrice && 
    !item.supportDocuments
  );

  // CRITICAL: This pushes the error that triggers the "both tables empty" warning
  if (isOtherTableEmpty && isBlastingTableEmpty) {
    errors.push("Both tables are empty. Please fill at least one row in the \"Blasting Cost Drivers\" table or \"Other Cost Drivers\" table. You can also fill both tables if needed.");
    // This sets showCostDriverWarning to true
    setShowCostDriverWarning(true);
  } else {
    setShowCostDriverWarning(false);
  }

  // Other cost driver validation
  if (!isOtherTableEmpty && !hasFilledOtherCostDriver) {
    const hasPartialOther = costItems.some(item => 
      item.costDriver || item.justification || item.quantity || item.unitPrice || item.supportDocuments
    );
    if (hasPartialOther) {
      errors.push("Please complete all fields in the row/rows in the \"Other Cost Drivers\" table, or remove empty rows");
    }
  }

  // Blasting cost driver validation
  if (!isBlastingTableEmpty && !hasFilledBlastingCostDriver) {
    const hasPartialBlasting = blastingCostItems.some(item => 
      item.costDriver || item.justification || item.quantity || item.unitPrice || item.supportDocuments
    );
    if (hasPartialBlasting) {
      errors.push("Please complete all fields in the row/rows in the \"Blasting Cost Drivers\" table, or remove empty rows");
    }
  }

  // Individual row validation
  if (costItems.length > 0 && hasFilledOtherCostDriver) {
    costItems.forEach((item, index) => {
      if (item.costDriver || item.justification || item.quantity || item.unitPrice || item.supportDocuments) {
        if (!item.costDriver) errors.push(`Other Cost Driver #${index + 1}: Name is required`);
        if (!item.justification) errors.push(`Other Cost Driver #${index + 1}: Justification is required`);
        if (!item.quantity || Number(item.quantity) <= 0) errors.push(`Other Cost Driver #${index + 1}: Valid quantity is required`);
        if (!item.unitPrice || Number(item.unitPrice) <= 0) errors.push(`Other Cost Driver #${index + 1}: Valid unit price is required`);
        if (!item.supportDocuments) errors.push(`Other Cost Driver #${index + 1}: Support documents description is required`);
      }
    });
  }

  if (blastingCostItems.length > 0 && hasFilledBlastingCostDriver) {
    blastingCostItems.forEach((item, index) => {
      if (item.costDriver || item.justification || item.quantity || item.unitPrice || item.supportDocuments) {
        if (!item.costDriver) errors.push(`Blasting Cost Driver #${index + 1}: Name is required`);
        if (!item.justification) errors.push(`Blasting Cost Driver #${index + 1}: Justification is required`);
        if (!item.quantity || Number(item.quantity) <= 0) errors.push(`Blasting Cost Driver #${index + 1}: Valid quantity is required`);
        if (!item.unitPrice || Number(item.unitPrice) <= 0) errors.push(`Blasting Cost Driver #${index + 1}: Valid unit price is required`);
        if (!item.supportDocuments) errors.push(`Blasting Cost Driver #${index + 1}: Support documents description is required`);
      }
    });
  }

  // ===== 5. DISTRICT & AREA PROGRAM VALIDATION =====
  if (formData.districtAndAreaProgramPairs.length === 0) {
    errors.push("At least one District and Area Program pair is required");
  } else {
    formData.districtAndAreaProgramPairs.forEach((pair, index) => {
      if (!pair.district) errors.push(`District name is required`);
      if (!pair.areaProgram) errors.push(`Area Program or EPA name is required`);
    });
  }

  return errors;
};

        const handleSubmit = async (event) => {            
          setIsSubmitting(true);
          setSubmitAttempted(true);
          try {
            console.log("handleSubmit triggered");
            event.preventDefault();
        
console.log('Form validation state: (before  const validationErrors = validateFormBeforeSubmit(); line of code', {
  projectCode: { value: formData.projectCode, shouldBeRed: submitAttempted && !formData.projectCode },
  projectName: { value: formData.projectName, shouldBeRed: submitAttempted && !formData.projectName },
  budgetLineCode: { value: formData.budgetLineCode, shouldBeRed: submitAttempted && !formData.budgetLineCode },
  payMode: { value: formData.payMode, shouldBeRed: submitAttempted && !formData.payMode },
  submitAttempted: submitAttempted
});
            const validationErrors = validateFormBeforeSubmit();

            console.log('Form validation state: (after  const validationErrors = validateFormBeforeSubmit(); line of code', {
  projectCode: { value: formData.projectCode, shouldBeRed: submitAttempted && !formData.projectCode },
  projectName: { value: formData.projectName, shouldBeRed: submitAttempted && !formData.projectName },
  budgetLineCode: { value: formData.budgetLineCode, shouldBeRed: submitAttempted && !formData.budgetLineCode },
  payMode: { value: formData.payMode, shouldBeRed: submitAttempted && !formData.payMode },
  submitAttempted: submitAttempted
});
            if (validationErrors.length > 0) {
              setValidationErrorMessages(validationErrors);
              setShowValidationErrorModal(true);
              setIsSubmitting(false);
              return;
            }
            if (!navigator.onLine) {
              setShowNoInternetModal(true);
              return;
            }
        
            const requisitionDateTime = DateTime.now()
              .setZone("Africa/Harare")
              .toISO();
        
            const fullName = localStorage.getItem("fullName") || "Name";
        
            // Function to check if a row is filled
            const isRowFilled = (item) => {
              return item.costDriver && 
                    item.costDriver.trim() !== '' && 
                    item.justification && 
                    item.justification.trim() !== '' && 
                    item.quantity && 
                    Number(item.quantity) > 0 && 
                    item.unitPrice && 
                    Number(item.unitPrice) > 0 && 
                    item.supportDocuments && 
                    item.supportDocuments.trim() !== '';
            };

            // Get filled cost drivers - only include rows that are completely filled
            let updatedCostDrivers = costItems
              .filter(item => isRowFilled(item))
              .map((driver) => ({
                costDriver: driver.costDriver,
                justification: driver.justification,
                quantity: Number(driver.quantity),
                unitPrice: Number(driver.unitPrice),
                total: (Number(driver.quantity) || 0) * (Number(driver.unitPrice) || 0),
                supportDocuments: driver.supportDocuments,
                totalTotal: totalTotal || 0
              }));

            // Get filled blasting cost drivers - only include rows that are completely filled
            let updatedBlastingCostDrivers = blastingCostItems
              .filter(item => isRowFilled(item))
              .map((item) => ({
                costDriver: item.costDriver,
                justification: item.justification,
                quantity: Number(item.quantity),
                unitPrice: Number(item.unitPrice),
                total: (Number(item.quantity) || 0) * (Number(item.unitPrice) || 0),
                supportDocuments: item.supportDocuments,
                totalTotal: blastingTotalTotal || 0
              }));

            // No placeholder needed anymore since backend validation is updated
            // We can send empty arrays if no data exists in a table
            const districtAndAreaProgramPairsWithRequisitionID =
              formData.districtAndAreaProgramPairs.map((pair) => ({
                ...pair,
              }));

            console.log("Submitting cost drivers:", updatedCostDrivers);
            console.log("Submitting blasting cost drivers:", updatedBlastingCostDrivers);

            const updatedFormData = {
              ...formData,
              requisitionDate: requisitionDateTime,
              costDrivers: updatedCostDrivers,
              blastingCostDrivers: updatedBlastingCostDrivers,
              districtAndAreaProgramPairs: districtAndAreaProgramPairsWithRequisitionID,
              status: "Submitted",
            };        
            console.log("updated form data:", updatedFormData);
        
            const response = await axios.post(
              `${process.env.REACT_APP_API_BASE_URL}/requisition`,
              updatedFormData
            );
            console.log("Submission successful:", response.data);

            
            const generatedRequisitionID = response.data.requisitionID;
            console.log("Generated Requisition ID from backend:", generatedRequisitionID);
                
            setFormData((prev) => ({
              ...prev,
              status: "Submitted",
            }));
            setShowModal(true);
          } catch (error) {
            console.log("FULL ERROR OBJECT:", error);
            
            if (error.response) {
                console.log("RESPONSE DATA:", error.response.data);
                console.log("RESPONSE STATUS:", error.response.status);
                console.log("RESPONSE HEADERS:", error.response.headers);
                
                if (error.response.request && error.response.request.response) {
                    console.log("RAW RESPONSE TEXT:", error.response.request.response);
                }
                
                const errorMessage = error.response.data?.message || 
                                    error.response.data?.title ||
                                    error.response.data?.error ||
                                    JSON.stringify(error.response.data);
                
                console.log("EXTRACTED ERROR MESSAGE:", errorMessage);
                
                // Show error in modal instead of alert
                setValidationErrorMessages([`Server Error: ${errorMessage}`]);
                setShowValidationErrorModal(true);
            } else if (error.request) {
                console.log("No response received");
                setValidationErrorMessages(["No response received from server. Please check your connection."]);
                setShowValidationErrorModal(true);
            } else {
                console.log("Error setting up request:", error.message);
                setValidationErrorMessages([`Error: ${error.message}`]);
                setShowValidationErrorModal(true);
            }
            
            setShowErrorModal(true);
          }  finally {
            setIsSubmitting(false);
          }
        };
                 

        const formatCurrency = (value) => {
            if (value === null || value === undefined) {
                return 'MK 0';
            }
            const numValue = Number(value);
            if (isNaN(numValue)) {
                return 'MK 0';
            }
            return `MK ${numValue.toLocaleString('en-US')}`;
        };   
                
        const handleDistrictChange = (index, selectedOption) => {
            const updatedPairs = [...formData.districtAndAreaProgramPairs];
            updatedPairs[index].district = selectedOption ? selectedOption.value : ""; 
            setFormData({ ...formData, districtAndAreaProgramPairs: updatedPairs });
        };
        
        const [districtAPPairs, setDistrictAPPairs] = useState([
          { district: "", areaProgram: "" }, 
        ]);
        
        const districtOptions = districts.map((district) => ({
          value: district,
          label: district
        }));

        const handleAreaProgramChange = (index, value) => {
          const updatedPairs = [...formData.districtAndAreaProgramPairs];
          updatedPairs[index].areaProgram = value;
          setFormData({ ...formData, districtAndAreaProgramPairs: updatedPairs });
      };

      const removeDistrictAPPair = (index) => {
        const updatedPairs = formData.districtAndAreaProgramPairs.filter((_, i) => i !== index);
        setFormData({ ...formData, districtAndAreaProgramPairs: updatedPairs });
    };
      
        

        

        const addDistrictAPPair = () => {
          const updatedPairs = [...formData.districtAndAreaProgramPairs, { district: "", areaProgram: "" }];
          setFormData({ ...formData, districtAndAreaProgramPairs: updatedPairs });
      };

      useEffect(() => {
          const newTotalTotal = blastingCostItems.reduce((acc, item) => acc + (Number(item.quantity || 0) * Number(item.unitPrice || 0)), 0);
          setBlastingTotalTotal(newTotalTotal);
      }, [blastingCostItems]);

      // Monitor if one table is filled and the other is empty (only after submit attempt)
      useEffect(() => {
        // Only check if user has attempted to submit
        if (!submitAttempted) {
          setShowEmptyTableWarning(false);
          return;
        }
        
        // Check if a table has any data (partial or complete)
        const hasAnyDataInOther = costItems.some(item => 
          item.costDriver || item.justification || item.quantity || item.unitPrice || item.supportDocuments
        );
        
        const hasAnyDataInBlasting = blastingCostItems.some(item => 
          item.costDriver || item.justification || item.quantity || item.unitPrice || item.supportDocuments
        );
        
        // If BOTH tables have data OR BOTH tables are empty, hide warning
        if ((hasAnyDataInOther && hasAnyDataInBlasting) || (!hasAnyDataInOther && !hasAnyDataInBlasting)) {
          setShowEmptyTableWarning(false);
        } else {
          // One table has data and the other is empty - show warning
          setShowEmptyTableWarning(true);
        }
      }, [costItems, blastingCostItems, submitAttempted]);

/*
      useEffect(() => {
        const fullName = localStorage.getItem('fullName') || "Name";
        if (fullName && thePhoneNumber !== undefined && currentRequisitionsOnDate !== undefined) {
          const newRequisitionID = generateRequisitionID(
            fullName,
            thePhoneNumber,
            currentRequisitionsOnDate
          );
          
          setFormData(prevData => ({
            ...prevData,
            requisitionID: newRequisitionID
          }));
          
          console.log("Generated Requisition ID:", newRequisitionID); 
        }
      }, [fullName, thePhoneNumber, currentRequisitionsOnDate]);
*/
    return (
      <div>

          
          
      
      
        <div id="wrapper">
          <LoadingOverlay isVisible={isSubmitting} />
          
          <Sidebar userType={theUserType} />


{/* Content Wrapper */}

<div id="content-wrapper" className="d-flex flex-column">

    {/* Main Content */}
    <div id="content">
    {/* Topbar */}
    <nav className="navbar navbar-expand navbar-light bg-white topbar mb-4 static-top shadow">

    {/* Sidebar Toggle */}
    <button id="sidebarToggleTop" className="btn btn-link d-md-none rounded-circle mr-3">
        <i className="fa fa-bars"></i>
    </button>

    {/* Topbar Search */}
    <form className="d-none d-sm-inline-block form-inline mr-auto ml-md-3 my-2 my-md-0 mw-100 navbar-search">
        <div className="input-group">
            <input type="text" className="form-control bg-light border-0 small" placeholder="Search"
                aria-label="Search" aria-describedby="basic-addon2" />
            <div className="input-group-append">
                <button className="btn btn-primary" type="button">
                    <i className="fas fa-search fa-sm"></i>
                </button>
            </div>
        </div>
        
    </form>
    

    {/* Topbar Navbar */}
    <ul className="navbar-nav ml-auto">

        <TopBarIcons />
        
        

    </ul>

    </nav>
    {/* End of Topbar */}

        {/* Begin Page Content */}
<div className="container-fluid">
  {/* Buttons Wrapper */}
  <div className="buttons-container">
        
      <PrintButton targetId="printable-area"   />

      <ExportExcelButton
        formArray={formArray}
        setFormArray={setFormArray}
        currentFormData={formData}
        costItems={costItems} 
        fileName="Requisition Form.xlsx"
      />
      <ExportPDFButton contentRef={contentRef} />
  </div>

    <div id="printable-area" ref={contentRef}style={{ padding: '20px' }}>
      <form onSubmit={handleSubmit}> 
        <div className="required-note" hidden>
          <small>Required/Mandatory fields are marked with <span style={{color: 'red'}}>*</span> </small>
        </div>
       {/*<form onSubmit={handleSubmit} autocomplete="off">*/}
          <div className="form-group" >
            
            <div className="view-requisition-header">
                <button
                  type="button"
                  onClick={() => navigate(-1)}
                  className="nav-link btn p-0"
                  style={{ background: 'none', border: 'none' }}
                >
                  <i className="fas fa-arrow-left back-button"></i> {/* Back */}
                </button>
                <h1 className="form-heading h3 mb-4 text-gray-800">Requisition Form</h1>
            </div>

                <div className="requisition-date-and-id" hidden>
                    <div>
                        <label>Requisition Date:</label>
                        <input type="date" value={formData.requisitionDate} readOnly />
                    </div>

                    <div>
                        <label>Requisition ID:</label>
                        <input type="text" value={formData.requisitionID || ''} readOnly />
                    </div>
                </div>
                
                
                <div className="staff-activity-container">
                    {/* Staff Details */}
                    <div className="form-group">
                      <h3>Staff Details</h3>
                      <div className="form-field">
                        <label>Staff Name</label>
                        <input
                          type="text"
                          name="staffName"
                          value={formData.staffName}
                          onChange={(e) => setFormData({ ...formData, staffName: e.target.value })}
                          readOnly
                          className="read-only"
                        />
                      </div>
                      <div className="form-field">
                        <label>Staff Level</label>
                        <input
                          type="text"
                          name="staffLevel"
                          value={formData.staffLevel}
                          onChange={(e) => setFormData({ ...formData, staffLevel: e.target.value })}
                          readOnly
                          className="read-only"
                        />
                      </div>
                      <div className="form-field">
                        <label>Supervisor Name</label>
                        <input
                          type="text"
                          name="supervisorName"
                          value={formData.supervisorName}
                          onChange={(e) => setFormData({ ...formData, supervisorName: e.target.value })}
                          readOnly
                          className="read-only"
                        />
                      </div>
                      <div className="hidden-field">
                        <div className="form-field">
                          <label>User Type</label>
                          <input
                            type="text"
                            name="userType"
                            value={formData.userType}
                            onChange={(e) => setFormData({ ...formData, userType: e.target.value })}
                          />
                        </div>
                        <div className="form-field">
                          <label>User ID</label>
                          <input
                            type="text"
                            name="userId"
                            value={formData.userId}
                            onChange={(e) => setFormData({ ...formData, userId: e.target.value })}
                          />
                        </div>
                    </div>



                    </div>

                    {/* Activity Details */}
                    <div className="form-group">
                      <h3>Activity Details</h3>
                      <div className="form-field">
                        <div className="field-container">
                          <label>Activity Duration</label>
                          <div className="date-input-container">
                            <label>From:<span className="required-asterisk">*</span></label>
                            <div className="date-input-wrapper">
                              <input
                                type="date"
                                name="from"
                                value={formData.from}
                                onChange={(e) => {
                                  setFormData({ ...formData, from: e.target.value });
                                  e.target.classList.toggle('has-value', e.target.value !== '');
                                }}
                                className={submitAttempted && !formData.from ? 'required-field' : (formData.from ? 'has-value' : '')}
                              />
                              <i className="fas fa-calendar-alt"></i>
                            </div>
                          </div>
                          <div className="date-input-container">
                            <label>To:<span className="required-asterisk">*</span></label>
                            <div className="date-input-wrapper">
                              <input
                                type="date"
                                name="to"
                                value={formData.to}
                                onChange={(e) => {
                                  setFormData({ ...formData, to: e.target.value });
                                  e.target.classList.toggle('has-value', e.target.value !== '');
                                }}
                                className={submitAttempted && !formData.to ? 'required-field' : (formData.to ? 'has-value' : '')}
                              />
                              <i className="fas fa-calendar-alt"></i>
                            </div>
                          </div>
                        </div>
                      </div>
                      <br/>
                      <div className="form-field">
                        <label>Activity Name<span className="required-asterisk">*</span></label>
                        <input
                          type="text"
                          name="activityName"
                          value={formData.activityName}
                          onChange={(e) => setFormData({ ...formData, activityName: e.target.value })}
                          className={submitAttempted && !formData.activityName ? 'required-field' : ''}
                        />
                      </div>
                      <div className="form-field">
                        <label>Activity Purpose<span className="required-asterisk">*</span></label>
                        <input
                          type="text"
                          name="activityPurpose"
                          value={formData.activityPurpose}
                          onChange={(e) => setFormData({ ...formData, activityPurpose: e.target.value })}
                          className={submitAttempted && !formData.activityPurpose ? 'required-field' : ''}
                        />
                      </div>
                      <div className="form-field">
                        <label>Target Client<span className="required-asterisk">*</span></label>
                        <StyledInput
                          type="text"
                          name="targetClient"
                          placeholder="Number & Name of Target Client e.g. 40 LMFs"
                          value={formData.targetClient}
                          onChange={(e) => setFormData({ ...formData, targetClient: e.target.value })}
                          className={submitAttempted && !formData.targetClient ? 'required-field' : ''}
                        />
                      </div>
                      <div className="form-field">
                        <label>Expected Impact<span className="required-asterisk">*</span></label>
                        <input
                          type="text"
                          name="expectedImpact"
                          value={formData.expectedImpact}
                          onChange={(e) => setFormData({ ...formData, expectedImpact: e.target.value })}
                          className={submitAttempted && !formData.expectedImpact ? 'required-field' : ''}
                        />
                      </div>
                      <div className="form-field">
                        <label>Country<span className="required-asterisk">*</span></label>
                        <input
                          type="text"
                          name="country"
                          value={formData.country}
                          onChange={(e) => setFormData({ ...formData, country: e.target.value })}
                          className={submitAttempted && !formData.country ? 'required-field' : ''}
                        />
                      </div>
                     {formData.districtAndAreaProgramPairs.map((pair, index) => (
                      <div key={index} className="field-container">
                        <div className="form-field">
                          <label>District<span className="required-asterisk">*</span></label>
                          <div className={submitAttempted && !pair.district ? 'react-select-required' : ''}>
                            <Select
                              options={districtOptions}
                              value={districtOptions.find(
                                (option) => option.value === pair.district
                              )}
                              onChange={(selectedOption) =>
                                handleDistrictChange(index, selectedOption)
                              }
                              placeholder="Select District"
                              isClearable
                              className="custom-select-control"
                            />
                          </div>
                        </div>
                        <div className="form-field">
                          <label>Area Program (AP) / EPA<span className="required-asterisk">*</span></label>
                          <input
                            type="text"
                            value={pair.areaProgram}
                            onChange={(e) =>
                              handleAreaProgramChange(index, e.target.value)
                            }
                            placeholder="Enter Area Program / EPA"
                            className={submitAttempted && !pair.areaProgram ? 'required-field' : ''}
                          />
                        </div>

                          {/* "+" button for the first pair */}
                          {index === 0 && (
                            <button
                              type="button"
                              className="add-button"
                              onClick={addDistrictAPPair}
                            >
                              +
                            </button>
                          )}

                          {/* "X" button for all pairs except the first one */}
                          {index > 0 && (
                            <button
                              type="button"
                              className="remove-button"
                              onClick={() => removeDistrictAPPair(index)}
                            >
                              X
                            </button>
                          )}
                        </div>
                      ))}

                      <div className="form-field">
                        <label>Hub Office<span className="required-asterisk">*</span></label>
                        <input
                          type="text"
                          name="hubOffice"
                          value={formData.hubOffice}
                          onChange={(e) => setFormData({ ...formData, hubOffice: e.target.value })}
                          className={submitAttempted && !formData.hubOffice ? 'required-field' : ''}
                        />
                      </div>
                      </div>
                  

                {/* Project & Advance Details */}
                <div className="form-group">
                  <h3>Project & Advance Details</h3>
                  <div className="form-field">
                    <label>Project Code<span className="required-asterisk">*</span></label>
                    <input
                      type="text"
                      name="projectCode"
                      value={formData.projectCode}
                      onChange={(e) => setFormData({ ...formData, projectCode: e.target.value })}
                      className={submitAttempted && !formData.projectCode ? 'required-field' : (formData.projectCode ? 'has-value' : '')}

                      
                    />
                  </div>
                  <div className="form-field">
                    <label>Project Name<span className="required-asterisk">*</span></label>
                    <input
                      type="text"
                      name="projectName"
                      value={formData.projectName}
                      onChange={(e) => setFormData({ ...formData, projectName: e.target.value })}
                      className={submitAttempted && !formData.projectName ? 'required-field' : ''}
                    />
                  </div>
                  <div className="form-field">
                    <label>Budget Line Code<span className="required-asterisk">*</span></label>
                    <input
                      type="text"
                      name="budgetLineCode"
                      value={formData.budgetLineCode}
                      onChange={(e) => setFormData({ ...formData, budgetLineCode: e.target.value })}
                      className={submitAttempted && !formData.budgetLineCode ? 'required-field' : ''}
                    />
                  </div>
                  <div className="form-field">
                    <label>Pay Mode<span className="required-asterisk">*</span></label>
                    <select
                      name="payMode"
                      value={formData.payMode}
                      onChange={(e) => setFormData({ ...formData, payMode: e.target.value })}
                      className={submitAttempted && !formData.payMode ? 'required-field' : ''}
                    >
                      <option value="">Select Pay Mode</option>
                      <option value="Bank">Bank</option>
                      <option value="Airtel Money">Airtel Money</option>
                      <option value="TNM Mpamba">TNM Mpamba</option>
                      <option value="cash">Cash</option>
                    </select>
                  </div>

                  {formData.payMode === 'Bank' && (
                    <div>
                      <div className="form-field">
                        <label>Bank Name</label>
                        <input
                          type="text"
                          name="bankName"
                          value={formData.bankName}
                          onChange={(e) => setFormData({ ...formData, bankName: e.target.value })}
                        />
                      </div>
                      <div className="form-field">
                        <label>Branch</label>
                        <input
                          type="text"
                          name="branch"
                          value={formData.branch}
                          onChange={(e) => setFormData({ ...formData, branch: e.target.value })}
                        />
                      </div>
                      <div className="form-field">
                        <label>Your Account Number</label>
                        <input
                          type="text"
                          name="accountNumber"
                          value={formData.accountNumber}
                          onChange={(e) => setFormData({ ...formData, accountNumber: e.target.value })}
                        />
                      </div>
                    </div>
                  )}
                  {(formData.payMode === 'Airtel Money' || formData.payMode === 'TNM Mpamba') && (
                    <div className="form-field">
                      <label>Phone Number</label>
                      <input
                        type="text"
                        name="phoneNumber"
                        value={formData.phoneNumber}
                        onChange={(e) => setFormData({ ...formData, phoneNumber: e.target.value })}
                      />
                    </div>
                  )}
                </div>
                </div>
                </div>
            <div id="cost-drivers-wrapper">
             {/* Required note - only show when both tables are empty and user tries to submit */}
            {/* Required note - only show when both tables are empty and user tries to submit */}
            {showCostDriverWarning && submitAttempted && (
              <div className="cost-drivers-required-note">
                <span className="note-icon">*</span>
                <div className="note-content">
                  <strong className="note-title">Note:</strong>
                  <span className="note-text">
                    {' '}One of the tables below must have a minimum of one completely filled row. You can fill both tables if needed.
                  </span>
                  <div className="note-detail">
                    A row is considered <strong>complete</strong> when all fields are filled (Cost Driver, Justification, Quantity, Unit Price and Support Documents).
                  </div>
                </div>
              </div>
            )}


            <div id="blasting-div">
              <h3 id="blasting-heading">Blasting Cost Drivers</h3> 
              <div id="blasting-ignore-text" className="italic-text">(This table should be empty if you are NOT blasting)</div>
              
              {/* Warning message for empty Blasting table - only after submit attempt */}
              {submitAttempted && (() => {
                // Check if Other table has ANY data (partial or complete)
                const hasAnyDataInOther = costItems.some(item => 
                  item.costDriver || item.justification || item.quantity || item.unitPrice || item.supportDocuments
                );
                
                // Check if Blasting table is COMPLETELY empty
                const isBlastingCompletelyEmpty = blastingCostItems.every(item => 
                  !item.costDriver && !item.justification && !item.quantity && !item.unitPrice && !item.supportDocuments
                );
                
                // Show warning ONLY if Other has data AND Blasting is completely empty
                return (hasAnyDataInOther && isBlastingCompletelyEmpty) ? (
                  <div className="empty-table-warning">
                    <span className="warning-icon">⚠️</span>
                    <div className="warning-content">
                      <strong className="warning-title">Warning:</strong>
                      <span className="warning-text">
                        {' '}Are you sure that you want to submit the requisition without filling this table? If yes, ignore this message. If no, please fill in the table below too
                      </span>
                    </div>
                  </div>
                ) : null;
              })()}              
            </div>
                <div id="blasting-section">
                    <table className="table table-bordered">
                        <thead>
                            <tr>
                                <th>Cost Driver</th>
                                <th>Justification</th>
                                <th>Quantity</th>
                                <th>Unit Price</th>
                                <th>Total</th>
                                <th>Support Documents</th>
                            </tr>
                        </thead>
                        <tbody>
                            {blastingCostItems.map((item, index) => (
                                <tr key={index}>
                                  <td>
                                    <div className="input-container d-flex align-items-center">
                                      <span style={{ marginRight: '6px', fontWeight: 'bold' }}>{index + 1}.</span>
                                      {item.isCustom ? (
                                        <input
                                          type="text"
                                          value={item.customCostDriver || ''}
                                          onChange={(e) => {
                                            const newItems = [...blastingCostItems];
                                            newItems[index].customCostDriver = e.target.value;
                                            setBlastingCostItems(newItems);
                                          }}
                                          placeholder="Type the blasting cost driver"
                                          className={`form-control blasting-cost-driver-name ${submitAttempted && hasAnyData(blastingCostItems) && !item.customCostDriver ? 'required-field' : ''}`}
                                        />
                                      ) : (
                                        <Select
                                          options={[
                                            ...costDriverOptions.map((opt) => ({
                                              value: opt.costDriver,
                                              label: opt.costDriver,
                                            })),
                                            { value: 'Other', label: 'Other' }
                                          ]}
                                          value={
                                            item.costDriver
                                              ? { value: item.costDriver, label: item.costDriver }
                                              : null
                                          }
                                          onChange={(selectedOption) => {
                                            if (!selectedOption) {
                                              const newItems = [...blastingCostItems];
                                              Object.assign(newItems[index], {
                                                costDriver: "",
                                                isCustom: false,
                                                customCostDriver: "",
                                                supportDocuments: "",
                                                unitPrice: ""
                                              });
                                              setBlastingCostItems(newItems);
                                            } else if (selectedOption.value === "Other") {
                                              const newItems = [...blastingCostItems];
                                              Object.assign(newItems[index], {
                                                costDriver: "Other",
                                                isCustom: true,
                                                customCostDriver: "",
                                                supportDocuments: "",
                                                unitPrice: ""
                                              });
                                              setBlastingCostItems(newItems);
                                            } else {
                                              const newItems = [...blastingCostItems];
                                              const defaultUnitPrice = getDefaultUnitPrice(selectedOption.value);
                                              const supportDoc = getSupportDocuments(selectedOption.value);
                                              Object.assign(newItems[index], {
                                                costDriver: selectedOption.value,
                                                isCustom: false,
                                                customCostDriver: "",
                                                supportDocuments: supportDoc || "",
                                                unitPrice: defaultUnitPrice || ""
                                              });
                                              // Recalculate total
                                              const quantity = Number(newItems[index].quantity) || 0;
                                              const unitPrice = Number(defaultUnitPrice) || 0;
                                              newItems[index].total = quantity * unitPrice;
                                              setBlastingCostItems(newItems);
                                            }
                                          }}
                                          isClearable
                                          placeholder="Select Blasting Cost Driver"
                                          className="custom-select-control"
                                          styles={{
                                            control: (provided, state) => ({
                                              ...provided,
                                              borderColor: submitAttempted && hasAnyData(blastingCostItems) && !item.costDriver ? '#dc3545' : provided.borderColor,
                                            }),
                                          }}
                                        />
                                      )}
                                    </div>
                                  </td>

                                  <td>
                                    <textarea
                                      value={item.justification}
                                      onChange={(e) => handleBlastingInputChange(index, 'justification', e.target.value)}
                                      className={`form-control ${submitAttempted && hasAnyData(blastingCostItems) && !item.justification ? 'required-field' : ''}`}
                                      rows="2"
                                    />
                                  </td>
                                  <td>
                                    <input
                                      id="blasting-table-quantity-input-box"
                                      type="text"
                                      value={item.quantity === 0 || item.quantity === '' ? '' : Number(item.quantity).toLocaleString('en-US')}
                                      onChange={(e) => {
                                        const rawValue = e.target.value.replace(/,/g, '');
                                        handleBlastingInputChange(index, 'quantity', rawValue);
                                      }}
                                      className={`form-control ${submitAttempted && hasAnyData(blastingCostItems) && (!item.quantity || item.quantity <= 0) ? 'required-field' : ''}`}
                                      min="0"
                                      step="1"
                                    />
                                  </td>
                                  <td>
                                    <input
                                      type="text"
                                      value={item.unitPrice && item.unitPrice !== 0 && item.unitPrice !== '0' ? formatCurrency(item.unitPrice) : ''}
                                      onChange={(e) => {
                                        // Remove currency formatting and extract the raw number
                                        const rawValue = e.target.value.replace(/[^0-9.]/g, '');
                                        handleBlastingInputChange(index, 'unitPrice', rawValue);
                                      }}
                                      className={`form-control ${submitAttempted && hasAnyData(blastingCostItems) && (!item.unitPrice || item.unitPrice <= 0) ? 'required-field' : ''}`}
                                      min="0"
                                      step="0.01"
                                    />
                                  </td>
                                  <td>
                                    <input
                                      type="text"
                                      value={item.total && item.total !== 0 ? formatCurrency(item.total) : ''}
                                      readOnly
                                      className="form-control read-only-input"
                                    />
                                  </td>
                                  <td>
                                    <textarea
                                      value={item.supportDocuments}
                                      onChange={(e) => handleBlastingInputChange(index, 'supportDocuments', e.target.value)}
                                      className={`form-control ${submitAttempted && hasAnyData(blastingCostItems) && !item.supportDocuments ? 'required-field' : ''}`}
                                      rows="2"
                                    />
                                  </td>  
                     {isBlastingRowAdded && blastingCostItems.length > 1 && (
                                        <td className="delete-cell">
                                            <button
                                                type="button"
                                                className="btn btn-danger delete"
                                                onClick={() => removeBlastingRow(index)}
                                            >
                                                <i className="fas fa-times"></i>
                                            </button>
                                        </td>
                                    )}
                                </tr>
                            ))}
                        </tbody>
                        <tfoot>
                            <tr>
                               <td colSpan="4" style={{ textAlign: 'right' }}>
                                    <b>Blasting Total:</b>
                                </td>
                                <td>
                                    <input
                                        type="text"
                                        value={blastingTotalTotal && blastingTotalTotal !== 0 ? formatCurrency(blastingTotalTotal) : ''}
                                        readOnly
                                        className="form-control read-only-input"
                                    />
                                </td>
                                {isBlastingRowAdded && blastingCostItems.length > 1 && <td></td>}
                            </tr>
                        </tfoot>


                    </table>
                    
                    <button type="button" className="round-button" onClick={() => {
                        addBlastingRow();
                        setIsBlastingRowAdded(true);
                    }}>
                        <i className="fas fa-plus"></i>
                    </button>
                </div>





                     <h3 className="section-title">Other Cost Drivers</h3>

                    {/* Warning message for empty Other Cost Drivers table - only after submit attempt */}
                    {submitAttempted && (() => {
                      // Check if Blasting table has ANY data (partial or complete)
                      const hasAnyDataInBlasting = blastingCostItems.some(item => 
                        item.costDriver || item.justification || item.quantity || item.unitPrice || item.supportDocuments
                      );
                      
                      // Check if Other table is COMPLETELY empty
                      const isOtherCompletelyEmpty = costItems.every(item => 
                        !item.costDriver && !item.justification && !item.quantity && !item.unitPrice && !item.supportDocuments
                      );
                      
                      // Show warning ONLY if Blasting has data AND Other is completely empty
                      return (hasAnyDataInBlasting && isOtherCompletelyEmpty) ? (
                        <div className="empty-table-warning">
                          <div className="warning-content">
                            <strong className="warning-title">Warning:</strong>
                            <span className="warning-text">
                              {' '}Are you sure that you want to submit the requisition without filling this table? If yes, ignore this message. If no, please fill in the table below too
                            </span>
                          </div>
                        </div>
                      ) : null;
                    })()}                      <table className="table table-bordered">
                        <thead>
                          <tr>
                            <th>Cost Driver</th>
                            <th>Justification</th>
                            <th>Quantity</th>
                            <th>Unit Price</th>
                            <th>Total</th>
                            <th>Support Documents</th>
                          </tr>
                        </thead>
                        <tbody>
                          {costItems.map((item, index) => (
                            <tr key={index}>
                              <td>
                                <div className="input-container d-flex align-items-center">
                                  <span style={{ marginRight: '6px', fontWeight: 'bold' }}>{index + 1}.</span>
                                  {item.isCustom ? (
                                    <input
                                      type="text"
                                      value={item.customCostDriver}
                                      onChange={(e) => {
                                        const updatedItems = [...costItems];
                                        updatedItems[index].customCostDriver = e.target.value;
                                        setCostItems(updatedItems);
                                      }}
                                      placeholder="Type the Cost Driver"
                                      className={`form-control ${submitAttempted && hasAnyData(costItems) && !item.customCostDriver ? 'required-field' : ''}`}
                                    />
                                  ) : (
                                    <div className={submitAttempted && hasAnyData(costItems) && !item.costDriver ? 'react-select-required' : ''}>
                                      <Select
                                        options={[
                                          ...costDriverOptions.map((opt) => ({
                                            value: opt.costDriver,
                                            label: opt.costDriver,
                                          })),
                                        ]}
                                        value={
                                          item.costDriver
                                            ? { value: item.costDriver, label: item.costDriver }
                                            : null
                                        }
                                        onChange={(selectedOption) => {
                                          const updatedItems = [...costItems];

                                          if (!selectedOption) {
                                            Object.assign(updatedItems[index], {
                                              costDriver: "",
                                              isCustom: false,
                                              customCostDriver: "",
                                              supportDocuments: "",
                                              unitPrice: ""
                                            });
                                            // Recalculate total
                                            const quantity = Number(updatedItems[index].quantity) || 0;
                                            const unitPrice = 0;
                                            updatedItems[index].total = quantity * unitPrice;
                                          }
                                          else if (selectedOption.value === "Other") {
                                            Object.assign(updatedItems[index], {
                                              costDriver: "",
                                              isCustom: true,
                                              customCostDriver: "",
                                              supportDocuments: "",
                                              unitPrice: ""
                                            });
                                            // Recalculate total
                                            const quantity = Number(updatedItems[index].quantity) || 0;
                                            const unitPrice = 0;
                                            updatedItems[index].total = quantity * unitPrice;
                                          }
                                          else {
                                            const defaultUnitPrice = getDefaultUnitPrice(selectedOption.value);
                                            Object.assign(updatedItems[index], {
                                              costDriver: selectedOption.value,
                                              isCustom: false,
                                              customCostDriver: "",
                                              supportDocuments: getSupportDocuments(selectedOption.value),
                                              unitPrice: defaultUnitPrice,  
                                            });
                                            // Recalculate total with the new default unit price
                                            const quantity = Number(updatedItems[index].quantity) || 0;
                                            const unitPrice = Number(defaultUnitPrice) || 0;
                                            updatedItems[index].total = quantity * unitPrice;
                                          }

                                          setCostItems(updatedItems);
                                        }}
                                        isClearable
                                        placeholder="Select Cost Driver"
                                        className="custom-select-control"
                                      />
                                    </div>
                                  )}
                                </div>
                              </td>
                              <td>
                                <textarea
                                  value={item.justification || ''} 
                                  onChange={(e) => handleInputChange(index, 'justification', e.target.value)} 
                                  className={`form-control ${submitAttempted && hasAnyData(costItems) && !item.justification ? 'required-field' : ''}`}
                                  rows="3"
                                />
                              </td>
                              <td>
                                <input
                                  id="quantity-input-box"
                                  type="text"
                                  value={item.quantity === 0 || item.quantity === '' ? '' : Number(item.quantity).toLocaleString('en-US')}
                                  onChange={(e) => {
                                    const rawValue = e.target.value.replace(/,/g, '');
                                    handleInputChange(index, 'quantity', rawValue);
                                  }}
                                  className={`form-control ${submitAttempted && hasAnyData(costItems) && (!item.quantity || item.quantity === '0') ? 'required-field' : ''}`}
                                />
                              </td>
                              <td>
                                <div className="input-with-currency">
                                  <input
                                    type="text"
                                    value={item.unitPrice && item.unitPrice !== 0 && item.unitPrice !== '0' ? formatCurrency(item.unitPrice) : ''}
                                    onChange={(e) => handleInputChange(index, 'unitPrice', e.target.value.replace(/[^0-9.]/g, ''))}
                                    className={`form-control ${submitAttempted && hasAnyData(costItems) && (!item.unitPrice || item.unitPrice === '0') ? 'required-field' : ''}`}
                                  />
                                </div>
                              </td>
                              <td id="readOnly-total-table-cell">
                                <input
                                  type="text"
                                  value={item.total ? formatCurrency(item.total) : ''}
                                  readOnly
                                  className="form-control read-only-input"
                                />
                              </td>
                              <td id="support-documents-table-cell">
                                <textarea
                                  value={item.supportDocuments || ''}
                                  onChange={(e) => handleInputChange(index, 'supportDocuments', e.target.value)}
                                  className={`form-control ${submitAttempted && hasAnyData(costItems) && !item.supportDocuments ? 'required-field' : ''}`}
                                  rows="3"
                                  placeholder={item.costDriver === 'Other' ? 'Type the support document' : ''} 
                                />
                              </td>
                              {isRowAdded && (
                                <td>
                                  <button
                                    type="button"
                                    className="btn btn-danger delete"
                                    onClick={() => removeRow(index)}
                                  >
                                    <i className="fas fa-times"></i>
                                  </button>
                                </td>
                              )}
                            </tr>
                          ))}
                        </tbody>
                    <tfoot>
                      <tr>
                        <td colSpan="4" style={{ textAlign: 'right' }}>
                          <b>Other Cost Drivers Total:</b>
                        </td>
                        <td>
                          <input
                              type="text"
                              value={totalTotal && totalTotal !== 0 ? formatCurrency(totalTotal) : ''}
                              readOnly
                              className="form-control read-only-input"
                          />
                        </td>
                        <td></td>
                      </tr>
                    </tfoot>
                    </table>

                    </div> 




                {/* Add Row Button */}
                <button type="button" className=" round-button" onClick={addRow}>
                  <i class="fas fa-plus"></i>  
                </button>
                <br/>

                {/* Total Summary Section - Blasting Total + Other Cost Drivers Total */}
                <div className="total-summary-section">
                    <div className="total-item">
                        <div className="total-item-label">Blasting Total</div>
                        <div className="total-item-value">{formatCurrency(blastingTotalTotal)}</div>
                    </div>
                    <div className="total-operator">+</div>
                    <div className="total-item">
                        <div className="total-item-label">Other Cost Drivers Total</div>
                        <div className="total-item-value">{formatCurrency(totalTotal)}</div>
                    </div>
                    <div className="total-operator">=</div>
                    <div className="grand-total-box">
                        <div className="grand-total-label">Grand Total</div>
                        <div className="grand-total-value">{formatCurrency(blastingTotalTotal + totalTotal)}</div>
                    </div>
                </div>
                <br/>
                <br/>

                {/* Requester Comment Section */}
                <div className="form-group">
                  <h3>Message to Administration & Finance Team</h3>
                  <div className="form-field">
                    <textarea
                      value={formData.requesterComment || ''}
                      onChange={(e) => setFormData({ ...formData, requesterComment: e.target.value })}
                      placeholder="Add any additional comments or notes about this requisition (optional)"
                      className="form-control"
                      rows="4"
                      style={{
                        width: '100%',
                        padding: '12px',
                        border: '1px solid #ddd',
                        borderRadius: '5px',
                        fontSize: '16px',
                        resize: 'vertical',
                        minHeight: '100px'
                      }}
                    />
                    <small style={{ color: '#666', fontSize: '12px' }}>
                      For example: if you would like to request for the advance money to go into two seperate accounts
                    </small>
                  </div>
                </div>

                <br/><br/>

                <div className="checkbox-container">
                  <label className="checkbox-label">
                    <input
                      type="checkbox"
                      checked={isConfirmed}
                      onChange={handleCheckboxChange}
                      className="checkbox"
                    />
                    I confirm that the information provided is accurate.
                  </label>
                </div>

                {isConfirmed && (
                  <div className="signature-container">
                    <div className="signed-by-label">Signed by:</div>
                    <img
                      src={signatureUrl}
                      alt="User Signature"
                      className="signature-image"
                    />
                    <div className="user-full-name">{fullName}</div>
                    <br/>
                    <button type="submit" id="submit" className="btn btn-primary">Submit</button>
                  </div>
                )}


                <div className="requisition-date-and-id" id="status"> 
                          <div>
                              <label>Status:</label>
                              <input type="text" value={formData.status} readOnly />
                          </div>
                </div>

                <div>
                  
                 </div>

                 
              </form>

             
              <PopupModal
                title="Requisition Submitted"
                titleStyle = "success-title"
                message="Your requisition has been submitted successfully."
                icon={faCheckCircle}
                isVisible={showModal}
                onClose={handleModalClose}
                iconBorder="popup-modal-icon"
              />
              
              <PopupModal
                title="Error"
                titleStyle = "error-title"
                message="Please check that you have filled all the fields and try again."
                icon={faTimesCircle}
                iconColor="red"
                isVisible={showErrorModal}
                onClose={handleErrorModalClose}
                iconBorder="popup-modal-icon error"
              />
              
              <PopupModal
                title="Error"
                titleStyle="error-title"
                message={<ValidationErrorList errors={validationErrorMessages} />}
                icon={faTimesCircle}
                iconColor="red"
                isVisible={showValidationErrorModal}
                onClose={() => setShowValidationErrorModal(false)}
                iconBorder="popup-modal-icon error"
                confirmText="OK"
                onConfirm={() => setShowValidationErrorModal(false)}
              />

              <PopupModal
                title="No Internet Connection"
                message="Please check your internet connection and try again."
                icon={faWifi}
                iconColor="red" 
                isVisible={showNoInternetModal}
                onClose={handleNoInternetModalClose}
              />    

              </div>
              







        </div>
        {/* End of container-fluid */}
        <br/><br/><br/><br/><br/><br/><br/>

    </div>
    {/* End of Main Content */}


    {/* Footer */}
    <footer className="sticky-footer bg-white">
        <div className="container my-auto">
            <div className="copyright text-center my-auto">
                <span>Copyright &copy; Farm Concern International 2025</span>
            </div>
        </div>
    </footer>
    {/* End of Footer */}

</div>


    
    {/* End of Content Wrapper */}


           
          
          
        
      </div>   
    
 
</div>
);
};


export default RequisitionForm;